import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/lib/supabase";

export interface NavItem {
  label: string;
  path: string;
}

// Fallback navigation labels (in case DB fails)
const fallbackNav: NavItem[] = [
  { label: "Inicio", path: "/" },
  { label: "Miradas", path: "/miradas" },
  { label: "MásMed", path: "/masmed" },
  { label: "Evidencias", path: "/evidencias" },
  { label: "La Región", path: "/datos" },
  { label: "Noticias", path: "/noticias" },
  { label: "Contacto", path: "/contacto" },
];

const pageToPath: Record<string, string> = {
  inicio: "/",
  miradas: "/miradas",
  masmed: "/masmed",
  evidencias: "/evidencias",
  datos: "/datos",
  laregion: "/datos",
  noticias: "/noticias",
  contacto: "/contacto",
};

export function useNavLabels() {
  const [items, setItems] = useState<NavItem[]>(fallbackNav);
  const [loading, setLoading] = useState(true);

  const fetchNavLabels = useCallback(async () => {
    setLoading(true);
    try {
      const { data: result, error: err } = await supabase
        .from("heroes")
        .select("page, nav_label, title")
        .order("id", { ascending: true });
      if (err) throw err;

      if (result && result.length > 0) {
        const mapped: NavItem[] = result
          .map((row: any) => {
            const path = pageToPath[row.page];
            if (!path) return null;
            return {
              label: row.nav_label || row.title || row.page,
              path,
            };
          })
          .filter(Boolean) as NavItem[];

        // Ensure correct order based on fallback order
        const ordered: NavItem[] = [];
        for (const fb of fallbackNav) {
          const found = mapped.find((m) => m.path === fb.path);
          if (found) {
            ordered.push(found);
          }
        }
        // Add any extra pages not in fallback
        for (const m of mapped) {
          if (!ordered.find((o) => o.path === m.path)) {
            ordered.push(m);
          }
        }
        setItems(ordered);
      }
    } catch {
      // Keep fallback on error
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchNavLabels();
  }, [fetchNavLabels]);

  return { items, loading, refetch: fetchNavLabels };
}